import React from "react";
import { Link } from "react-router-dom";
import { observable, action } from "mobx";
import { sortCaret, IconeEditar } from "../../comum/components/Icones";
import { formatarDataCustomHTML, formatarDataISO8601 } from "../../../utils/formatar";
import NoticesServices from "../../../services/NoticesService";
import moment from "moment";

export default class NoticeStore {

    @observable notices
    @observable modelNotice

    constructor() {
        this.service = new NoticesServices()
        this.notices = []
        this.modelNotice = {
            "Status": this.selectStatus[0].value,
            "Tag": this.selectTag[0].value,
            "PublishAt": moment(),
        }
    }

    @action
    loadNotices = async () => {
        try {
            const { data } = await this.service.get()
            if (data && Array.isArray(data)) {
                this.notices = data
            }
        } catch (error) {
            console.error(error)
        }
    }

    @action
    getNotice = async (id) => {
        try {
            const { data } = await this.service.getById(id)
            return {
                ...data,
                PublishAt: (data.PublishAt) ? moment(data.PublishAt) : '',
                ExpirationAt: (data.ExpirationAt) ? moment(data.ExpirationAt) : ''
            }
        } catch (error) {
            console.error(error)
        }
    }

    @action
    saveNotice = async (notice) => {
        try {
            const { status, data } = await this.service.addOrEdit(notice)
            return { success: status === 200, data }
        } catch (error) {
            console.error(error)
            return { success: false, data: error }
        }
        return false
    }

    selectStatus = [
        { value: 'DRAFT', label: 'Draft' },
        { value: 'PUBLISH', label: 'Publish' },
        { value: 'TRASH', label: 'Trash' }
    ]

    selectTag = [
        { value: 'HOME', label: 'Home' },
        { value: 'NOTIFICACAO', label: 'Barra de Notificações' }
    ]

    columns = [
        { dataField: 'Id', text: '#', },
        { dataField: 'Title', text: 'Titulo', sort: true, sortCaret: sortCaret },
        { dataField: 'Status', text: 'Status', sort: true, sortCaret: sortCaret },
        { dataField: 'PublishAt', text: 'Publicado em', formatter: formatarDataCustomHTML, sort: true, sortCaret: sortCaret },
        { dataField: 'ExpirationAt', text: 'Expira em', formatter: formatarDataCustomHTML, sort: true, sortCaret: sortCaret },
        { dataField: 'CreatedBy', text: 'Criado por' },
        { dataField: 'CreatedAt', text: 'Criado em', formatter: formatarDataCustomHTML },
        { dataField: 'UpdatedBy', text: 'Atualizado por' },
        { dataField: 'UpdatedAt', text: 'Atuaizado em', formatter: formatarDataCustomHTML },
        {
            dataField: 'actions',
            text: '',
            isDummyField: true,
            formatter: (cell, row) =>
                <Link to={`notices/cadastro/${row.Id}`}>
                    <IconeEditar title={"Editar"} tamanho="lg" className="m-2" />
                </Link>,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/modules/notices/stores/NoticesStore.js